module.exports = __webpack_public_path__ + "media/application/images/ui/alert-icon-a7787c0690a69abf68a717767e29e79d.svg";